import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70" }

import { useI18n } from "vue-i18n";
import ToggleItem from "./ToggleItem.vue";
import { country } from "@ocm/services/ocm-object";
import type { Department } from "@ocm/global-types";


export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentToggle',
  setup(__props) {

const { t } = useI18n();

const departmentsMap = new Map<Department, string>(
	country === "int"
		? [
				["women", t("siteWide.searchApp.department.women")],
				["men", t("siteWide.searchApp.department.men")],
		  ]
		: [
				["damen", t("siteWide.searchApp.department.women")],
				["herren", t("siteWide.searchApp.department.men")],
				["kinder", t("siteWide.searchApp.department.kids")],
		  ]
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(departmentsMap), ([key, label]) => {
      return (_openBlock(), _createBlock(ToggleItem, {
        key: key,
        "department-type": key
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(label), 1)
        ]),
        _: 2
      }, 1032, ["department-type"]))
    }), 128))
  ]))
}
}

})